export default __webpack_public_path__ + "images/4D.812ba60.png";